<template>
  <div v-if="getExtensibles.length > 0">
    <b-row class="margin-0" v-if="!useModalView">
      <b-col lg="5" md="12" class="bg-light padding-0">
        <div class="border-0">
            <div class="email-app border-0">
                <main class="inbox border-0 padding-0">
                  <keep-alive>
                    <ExtensibleList :type="type" :extensibles="getExtensibles" 
                      @show-extensible-view="showExtensibleView"
                      @show-extensible-selection="updateExtensibleSelection"
                    />
                  </keep-alive>
                </main>
            </div>
        </div>
      </b-col>
      <b-col lg="7" md="0" class="pane-border d-md-down-none padding-0">
        <keep-alive v-if="!useModalView">
          <component
              :is="extensibleComponent"
              :extensible="selectedExtensible"
              :totalSelections="totalSelections" 
              :total="getExtensibles.length"
              @all-extensible-selections="allExtensibleSelections"
              @delete-extensible-selections="deleteSelectedExtensibles"
              @template-send-as-sms="handleSendAsSMS"
              @deleted-extensible="handleDeleted"
              @reloaded-questionnaire="handleReloadedQuestionnaire"
              :type="type"
          ></component>
        </keep-alive>
      </b-col>
    </b-row>
    <div v-else>
      <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
        <b-nav>
            <b-nav-item @click="useModalView = false"><i class="icon-arrow-left icons"></i></b-nav-item>
            <b-nav-item disabled> Back</b-nav-item>
            <!--b-nav-item><i class="cui-speech icons"></i> Free SMS</b-nav-item>
            <b-nav-item><i class="cui-comment-square icons"></i> Campaign SMS</b-nav-item-->
          </b-nav>
          <!-- Right aligned nav items -->
          <!--b-nav class="ml-auto">
            <b-nav-item><i class="icons icon-wallet"></i> Units Balance: {{Number(user.units_balance).toLocaleString()}}</b-nav-item>
          </b-nav-->
        </b-navbar>
          <!--keep-alive-->
            <component
              :is="extensibleComponent"
              :extensible="selectedExtensible"
              :totalSelections="totalSelections" 
              :total="getExtensibles.length"
              @all-extensible-selections="allExtensibleSelections"
              @delete-extensible-selections="deleteSelectedExtensibles"
              @template-send-as-sms="handleSendAsSMS"
              @deleted-extensible="handleDeleted"
              @reloaded-questionnaire="handleReloadedQuestionnaire"
              :type="type"
          ></component>
          <!--/keep-alive-->
    </div> 
  </div>
  <div v-else>
    <div class="module-action">
      <span class="mb-5 mt-5" style="opacity:0.7"><i class="icon-layers icons font-5xl d-block"></i></span>
      <h5>No Extensible {{type}} SMS!</h5>
      <span>You have not created any {{type}} Extensible SMS.</span>
      <span style="max-width:500px;" class="text-center">
        <small>Take your mobile marketing to more heights without breaking the bank. With all these Extensible SMS features at your finger tips you should start executing your mobile marketing campaign strategies by engaging in two-way conversations with your customers. </small>
      </span>
      <div class="mt-3">
        <b-button variant="primary" @click="showChooseType"><i class="icon-bubbles d-block "> Create Now</i></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { mapGetters, mapActions, mapState } from "vuex"
import ExtensibleList from '@/components/extensible-sms/ExtensibleList'
import {extensibleTypes} from '@/constants'
import ExtensibleAction from '@/components/extensible-sms/ExtensibleAction'
import ExtensibleView from '@/components/extensible-sms/ExtensibleView'
import {EventBus} from '@/events/bus.event'

export default {
  name: 'ExtensibleTypeView',
  components: {
      ExtensibleList,
      ExtensibleAction,
      ExtensibleView,
  },
  data () {
    return {
      extensibleTypes: extensibleTypes,
      useModalView: false,
      totalSelections: 0,
      selectedExtensible: null,
      extensibleComponent: ExtensibleAction,
      extensibleAction: ExtensibleAction,
      extensibleView: ExtensibleView,
      screenBreakPoint: 975,
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('extensibleSms', ['extensibles']),
    getExtensibles() {
        let extensibles = []
        switch (this.type) {
            case this.extensibleTypes.text:
                extensibles = this.extensibles.texts
                break;
            case this.extensibleTypes.image:
                extensibles = this.extensibles.images
                break;
            case this.extensibleTypes.audio:
                extensibles = this.extensibles.audios
                break;
            case this.extensibleTypes.video:
                extensibles = this.extensibles.videos
                break;
            case this.extensibleTypes.survey:
                extensibles = this.extensibles.surveys
                break;
            case this.extensibleTypes.vote:
                extensibles = this.extensibles.votes
                break;
            case this.extensibleTypes.poll:
                extensibles = this.extensibles.polls
                break;
        }
        
        return extensibles
    }
  },
  mounted() {
  },
  props: {
    type: String,
    isQuestionnaire: Boolean,
  },
  methods: {
    showChooseType: function() {
        this.$emit('show-extensible-type-chooser', this.type, this.isQuestionnaire)
    },

    handleResize () {
      this.useModalView = window.innerWidth < this.screenBreakPoint
    },

    showExtensibleView(e) {
      this.handleResize()
      
      if(this.totalSelections > 0)
          return

      //if(e.messages.length === 0)
        //this.fetchGroupMessages({groupId:e.id, page:e.messages_next_page})

      this.selectedExtensible = e
      this.extensibleComponent = this.extensibleView
    },

    updateExtensibleSelection: function (e, selected) {
      //this.useModalView = window.innerWidth <= this.screenBreakPoint
      selected ? this.totalSelections++ : this.totalSelections--

      if (this.totalSelections <= 0) {
        EventBus.$emit('extensible-selection-none')
        this.totalSelections = 0
        this.selectedExtensible = null
      }

      let extensibles = this.getExtensibles

      for (let i = 0; i < extensibles.length; i++) {
        if (extensibles[i].id === e.id) {
          extensibles[i].marked = selected
          break
        }
      }

      if (this.totalSelections > 0) {
        this.extensibleComponent = this.extensibleAction
      }
    },

    allExtensibleSelections: function (flag) {
      this.totalSelections = 0
      this.selectedExtensible = null
      EventBus.$emit('extensible-selection-none')

      let extensibles = this.getExtensibles
      for (let i = 0; i < extensibles.length; i++) {
        extensibles[i].marked = flag
        flag && this.totalSelections++
        EventBus.$emit('extensible-selection-'+extensibles[i].id, flag)
      }
      this.extensibleComponent = this.extensibleAction
    },

    async deleteSelectedExtensibles() {
      let ids = []
      let extensibles = this.getExtensibles
      for (let i = 0; i < extensibles.length; i++) {
        if (extensibles[i].marked) {
          ids.push(extensibles[i].id)
        }
      }
    },
    handleSendAsSMS: function(content) {
      this.$emit('template-send-as-sms', content)
    },
    handleDeleted: function() {
      this.extensibleComponent = this.extensibleAction
      this.selectedExtensible = null
    },
    handleReloadedQuestionnaire: function(questionnaire) {
      this.selectedExtensible = questionnaire
    }
  }
}
</script>

